import { render, staticRenderFns } from "./SubmissionResearch.vue?vue&type=template&id=776a77a8&scoped=true&"
import script from "./SubmissionResearch.vue?vue&type=script&lang=js&"
export * from "./SubmissionResearch.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionResearch.vue?vue&type=style&index=0&id=776a77a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a77a8",
  null
  
)

export default component.exports